// Imagenes
const images = {
    // cardInstructions: './assets/images/idea.png',
    logo: './assets/images/logo.png',
};

// -- URL DE PRUEBA CAMBIAR A DIRECCION EN SERVIDOR
const files = {
    device_received: '/assets/images/examples/' 
}

const indicators ={
    assessment: './assets/images/icons/assessment.png',
    tools: './assets/images/icons/tools.png',
    components: './assets/images/icons/components.png',
    money: './assets/images/icons/money.png',
    dollar: './assets/images/icons/dollar.png',
    debit: './assets/images/icons/debit.png',
    credit: './assets/images/icons/credit.png',
    cash: './assets/images/icons/cash.png',
    transfer: './assets/images/icons/transfer.png',
}

export { images, files, indicators };